import config from 'config'
import http_request from 'sync/http_raw'

const getFile = async (file, awsCredentials) => {
	const url = `${config.cloudfront}${file}`
	+ `?AWSAccessKeyId=${awsCredentials.s3AWSAccessKeyId}`
	+ `&Expires=${awsCredentials.s3Expires}`
	+ `&Signature=${encodeURIComponent(awsCredentials.s3Signature)}`

	return http_request
		.get(url)
		.send()
}

export default getFile
